import React, { useState } from 'react';
import CraftFilterItem from './CraftFilterItem';
import CraftFiltersSearch from './CraftFiltersSearch';

const CraftFilters = ({ filters, activeBlock, firstSelectedCard = null }) => {
  const [openedFilter, setOpenedFilter] = useState(null);


  const getFilteredFilters = (filters) => {
    if (firstSelectedCard) {
      return filters.filter(
        (filter) =>
          filter.name !== 'Collection' &&
          filter.name !== 'Categories' &&
          filter.name !== 'Event Type' &&
          filter.filter !== null &&
          (Array.isArray(filter.filter) ? filter.filter.length > 0 : true)
      );
    } else {
      return filters.filter((filter) => filter.filter !== null && (Array.isArray(filter.filter) ? filter.filter.length > 0 : true));
    }
  };

  const filteredFilters = getFilteredFilters(filters);

  return (
    <form className="craft-select__form">
      <CraftFiltersSearch activeBlock={activeBlock} />
      {filteredFilters.map((filter) => (
        <CraftFilterItem
          queryValue={filter.value}
          filter={filter}
          key={filter.name}
          openedFilter={openedFilter}
          setOpenedFilter={setOpenedFilter}
        />
      ))}
    </form>
  );
};

export default CraftFilters;

